var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 20C14.5547 20 17.8359 18.125 19.6328 15C21.4297 11.9141 21.4297 8.125 19.6328 5C17.8359 1.91406 14.5547 0 11 0C7.40625 0 4.125 1.91406 2.32812 5C0.53125 8.125 0.53125 11.9141 2.32812 15C4.125 18.125 7.40625 20 11 20ZM9.4375 13.125H10.375V10.625H9.4375H8.5V8.75H9.4375H11.3125H12.25V9.6875V13.125H12.5625H13.5V15H12.5625H9.4375H8.5V13.125H9.4375ZM12.25 7.5H9.75V5H12.25V7.5Z",
    fill: "#0088CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.91d2b3cb48bca6b4e7c42d87b38ac795.svg";
export { ForwardRef as ReactComponent };